import asyncSweetScroll from '@/helpers/sweet_scroll';
import { CITY_LANDING_PAGE_IDS } from '@/pages/city_landing/page_ids';

pageLoad(...CITY_LANDING_PAGE_IDS, () => {
  $('article.v4.head a[href="#map_top"]').on('click', event => {
    event.preventDefault();
    asyncSweetScroll('article.v4.storages_map');
  });
});
